import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { RentalDiscountItem } from '@tv3/containers/discounts/discounts-table/discounts-table.component'
import {
  GenericExportDialogComponent,
  GenericExportDialogConfig,
} from '@tv3/shared/dialogs/generic-export-dialog/generic-export-dialog.component'
import { Injectable } from '@angular/core'
import * as moment from 'moment'

@Injectable()
export class ExportDiscountsDialogService {
  constructor(private dialog: MatDialog) {}

  private getConfig(data: RentalDiscountItem[]): GenericExportDialogConfig {
    return {
      title: $localize`Download Discounts to CSV`,
      description: $localize`You are about to download all discounts within your current filter.`,
      columns: [
        { name: $localize`Name`, field: 'name' },
        { name: $localize`Discount Type`, field: 'discountTypeView' },
        { name: $localize`Type`, field: 'type' },
        { name: $localize`Amount`, field: 'amount' },
        { name: $localize`Start`, field: 'startView' },
        { name: $localize`End`, field: 'endView' },
      ],
      exportData: data,
      filename: `Discounts - ${moment().format('MM_DD_YYYY')}`,
      columnCustomizable: true,
    }
  }

  open(discounts: RentalDiscountItem[]) {
    const defaultConfig: MatDialogConfig = {
      width: '650px',
      height: 'auto',
      panelClass: ['variable-modal'],
      data: {
        config: this.getConfig(discounts),
      },
    }

    return this.dialog.open(GenericExportDialogComponent, defaultConfig)
  }
}
